
  import {spacing, typography} from 'material-ui/styles';

  const styles = {
    title: {
      cursor: 'pointer',
      fontSize: 22,
      color: 'white',
      lineHeight: `${spacing.desktopKeylineIncrement}px`,
      fontWeight: typography.fontWeightLight,
      backgroundColor: '#02ABCA',
      paddingLeft: 40,
      height: 56,
    },
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    menuItem: {
      color: '#666',
      fontSize: 14
    },
    avatar: {
      div: {
        padding: '15px 0 20px 15px',
        backgroundColor: '#02ABCA',
      },
      icon: {
        float: 'left',
        display: 'block',
        marginRight: 15,
        boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.2)'
      },
      span: {
        display: 'block',
        color: 'white',
        fontWeight: 300,
        textShadow: '1px 1px #444'
      }
    }
  };

  export default styles;


// WEBPACK FOOTER //
// ./src/containers/layout/styles/topMenuControlStyles.js